import { BasicButton, Tooltip } from "@certn/cascadia-react";
import { CascadiaMiniIcon } from "@certn/cascadia-tokens";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface Props {
  url: string;
  title?: string;
  icon?: CascadiaMiniIcon;
}

export function CopyLinkButton({ url, title, icon = "link" }: Props) {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const copyToClipboard = async (content: string) => {
    try {
      await navigator.clipboard.writeText(content);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1200);
    } catch (error) {
      console.warn(error);
      setIsCopied(false);
    }
  };

  return (
    <Tooltip
      placement="top"
      description={t("Copied")}
      testID="copy-link-button"
      isOpen={isCopied}
    >
      <BasicButton
        size="medium"
        testID="copy-link-button"
        leftIcon={icon}
        onPress={() => copyToClipboard(url)}
      >
        {title || t("Copy link")}
      </BasicButton>
    </Tooltip>
  );
}
